import { BaseModel } from './base.model'
import { Program } from './program.model'

export class StaticScreen extends BaseModel<StaticScreen> {
  static DEFAULT_ATTRIBUTES = {}

  comment: string
  content: string
  folderId: number
  id: number
  name: string
  programs: Program[]
  state: string
  nameTranslations: Object
  contentTranslations: Object
  availableLocales: string[]

  removed(): boolean {
    return this.state == 'removed'
  }

  disabled(): boolean {
    return this.state == 'disabled'
  }

  get availableLocalesString(): string {
    return this.availableLocales.length > 0 ? this.availableLocales.join(", ") : "Нет переводов"
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/models/static-screen.model.ts